<div class="pre-bin-check"
     [innerHTML]="context?.content?.headlineContent?.content|contentParse|safeHtml">
</div>
<ap-bin-check [title]="'binChecker.title'|content"
              [binLabel]="'binChecker.binLabel'|content"
              [binNumberControlHeader]="'binChecker.binNumberControlHeader'|content"
              [cardSelectLabel]="'binChecker.cardSelectLabel'|content"
              [checkBinLabel]="'binChecker.checkingBinLabel'|content"
              [selectCardFromLabel]="'binChecker.findCardContent'|htmlContent"
              [resetCardLabel]="'binChecker.tryAnotherCardContent'|htmlContent"
              [validationMessages]="'validationMessages.fieldErrors'|content"
              [displayOption]="cardOptionQuery.values | async"
              [cards]="cardQuery.values | async"
              [noBinError]="showBinNotFound"
              [alternativeBinError]="showAlternativeBinFound"
              (selected)="onCardSelected($event)"
              (binSearch)="onBinSearch($event)"
              (reset)="resetBin()"
              (clearNoBinError)="onClearNoBinError()"
              (clearAlternativeBinError)="onClearAlternativeBinError()">
</ap-bin-check>
<div *ngIf="showBinNotFound && 'binChecker.cardNotFound'|htmlContent" class="ap-card-not-eligible ap-bg-white ap-b ap-border-top ap-border-bottom ap-border-gray" >
  <div class="ap-container ap-pt-2 ap-pb-2">
    <div [innerHTML]="'binChecker.cardNotFound'|htmlContent|contentParse|safeHtml">
    </div>
  </div>
</div>
<div class="post-bin-check"
     [innerHTML]="context?.content?.pageContent?.content|contentParse|safeHtml">
</div>
